<template>
  <td :class="{'text-break': true, 'text-break-nowrap': setStyle ? setStyle.nowrap : '' }" :style="{ width: setStyle ? setStyle.width : '' }">
    {{ value }}
    <badge v-if="badgeStatus" :class="badgeStatus.class" :text="badgeStatus.text" />
  </td>
</template>

<script>
import Badge from '@/views/atoms/Badge';
export default {
  name: "TableData",
  components: {
    Badge,
  },
  props: {
    value: {
      type: [String, Number, null],
      required: true,
    },
    badgeStatus: {
      type: [Object, null],
      default: null,
    },
    setStyle: {
      type: [Object, null],
      default: null,
    },
  },
  emits: ['select'],
}
</script>

<style scoped>
.text-break-nowrap {
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}
</style>
